<template>
  <b-modal  ref="modal" visible size="lg" :hide-footer="true" title="inkooporder controleren" @hidden="$emit('close')">
    <div v-if="scannedProduct === null" class="text-center p-50">
        <div class="block-header block-header-default">
            <h3 class="block-title">
            Scan het in te boeken product...
            </h3>
      </div>
      <i class="fa fa-spin fa-5x fa-spinner" style="margin-top: 100px"></i>
      <div class="block-content" style="margin-top:100px">
        <button @click="completeOrderList" type="submit" class="btn btn-primary" style="float: right;">Inkooporder afronden</button>
    </div>
    </div>
    <div v-else>
      <div class="block-header block-header-default">
        <h3 class="block-title">
          Product uit inkooporde gescanned
        </h3>
      </div>
       <table class="table table-borderless table-striped table-hover" style="margin-left: auto; margin-right: auto; width: 90% !important;">
            <tbody>
                <td v-if="scannedProduct.image_urls">
                    <img class="img-avatar img-avatar48" :src="scannedProduct.image_urls[0]" alt="">
                </td>
                <td>
                  <a class="font-w600" href="#">{{scannedProduct.name}}</a>
                </td>
                <td>{{scannedProduct.stock_quantity}}</td>
                <td>
                    <location-editable field="location" :value="scannedProduct.location" :product-id="scannedProduct.id" :key="scannedProduct.id"></location-editable>
                </td>
            </tbody>
          </table>
        <div class="block-content">
            <div class="form-inline" style="margin-left: auto; margin-right: auto; width: 75% !important;">
                <div class="form-group">
                    <label for="amountDelivered" style="margin-right: 15px;">Aantal geleverd</label>
                    <input v-model="deliveredAmount" type="number" id="amountDelivered" class="form-control form-control-lg" style="margin-right: 15px;">
                    <button @click="bookProduct" type="submit" class="btn btn-primary btn-lg">Bij boeken</button>
                </div>
            </div>
        </div>
    </div>
    <unkown-product-modal v-if="unkownProductScanned" :barcode="scannedBarcode" @close="unkownProductScanned = null, scannedBarcode = null" @unkownProductCreated="handleUnkownProductCreated"></unkown-product-modal>
  </b-modal>
</template>
<script>
import http from '../utils/http'
import Socket from '../barcode-scanner/socket'
import UnkownProductModal from '../products/UnkownProductModal.vue'
import LocationEditable from '../products/LocationEditable'

export default {
  components: {
    UnkownProductModal,
    LocationEditable
  },
  props: {
    orderListId: Number
  },
  data () {
    return {
      unkownProductScanned: null,
      scannedBarcode: null,
      scannedProduct: null,
      deliveredAmount: null,
      orderList: null
    }
  },
  methods: {
    loadOrderList () {
      const params = {
        include: 'lines'
      }
      this.$api.getOrderList(this.orderListId, params)
        .then((result) => {
          this.orderList = result.data.data
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets fout gegaan. Probeer het opnieuw.', 'warning')
          this.$refs.modal.hide()
        })
    },
    handleMessage (event) {
      http.get(`/product-scanned/${event}`)
        .then((result) => {
          if (result.data.data === 'unknown_product') {
            this.unkownProductScanned = true
            this.scannedBarcode = event
            return
          }
          const product = result.data.data
          if (!this.isProductInOrderList(product.sku)) {
            this.$swal('Ehmm...', 'Dit product is geen onderdeel van de te controleren inkooporder. Probeer het opnieuw.', 'warning')
            return
          }
          this.scannedProduct = product
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze product konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    },
    isProductInOrderList (sku) {
      return (this.orderList.lines.filter(e => e.product_sku === sku).length > 0)
    },
    completeOrderList () {
      let status = 'completed'
      if (this.orderList.lines.filter(e => e.delivered_quantity !== e.ordered_quantity).length > 0) {
        status = 'incomplete'
      }
      const data = {
        status: status
      }
      http.patch(`/order-list/${this.orderList.id}`, data)
        .then((response) => {
          this.$swal('Hoera 😊', `De inkooporder is sucessvol bijgeboekt.`, 'success')
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze inkooporder. Probeer het opnieuw.', 'warning')
        })
    },
    handleUnkownProductCreated (event) {
      const data = {
        order_list_id: this.orderListId,
        product_sku: event.product.sku
      }

      this.$http.post(`/order-list-line`, data)
      .then((response) => {
        this.scannedProduct = event.product
      })
      .catch(() => {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het toevoegen van het onbekende product aan de inkooporder.  Probeer het opnieuw.`, 'error')
      })
    },
    bookProduct () {
      const data = {
        product_sku: this.scannedProduct.sku,
        delivered_quantity: this.deliveredAmount
      }
      http.patch(`/book-order-list-line/${this.orderListId}`, data)
        .then((result) => {
          this.$swal('Hoera 😊', `Het product is succesvol bijgeboekt.`, 'success')
          this.scannedProduct = null
          this.deliveredAmount = null
          this.loadOrderList()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het bijboeken van dit product. Probeer het opnieuw.', 'warning')
        })
    }
  },
  created () {
    this.loadOrderList()
    Socket.$on('message', this.handleMessage)
  },
  beforeDestroy () {
    Socket.$off('message', this.handleMessage)
  }
}
</script>



// WEBPACK FOOTER //
// CheckOrderListModal.vue?60a59fba